// @see https://github.com/AS3Commons/as3commons-lang/blob/master/src/main/actionscript/org/as3commons/lang/StringUtils.as
export class StringUtils {

  public static isEmpty(str:string):boolean {
    return str == null || str.length == 0;
	}

  private static safeRemove(str:string, pattern:RegExp):string {
		return StringUtils.isEmpty(str) ? str : str.replace(pattern, '');
	}

  public static remove(str:string, remove:string):string {
    return StringUtils.safeRemove(str, new RegExp(remove, 'g'));
  }

  public static removeEnd(str:string, remove:string):string {
    const regexSpecialChars = /([\^\$\(\[\]\)\.\?])/g;
    if (!StringUtils.isEmpty(str)) {
      remove = remove.replace(regexSpecialChars, '\\$1');
    }
		return StringUtils.safeRemove(str, new RegExp(remove + '$', ''));
	}

}

